import React from 'react'
import { NavLink } from 'react-router-dom'
 
const classNames = require('classnames')
 
const CustomNavLink = ({ to, children, onClick, icon, isReactIcon, className, end }) => {
  return (
    <NavLink
      to={to}
      end={end}
      onClick={onClick}
      className={({ isActive }) =>
        classNames(
          'flex items-center px-4 lg:px-7 py-3 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue transition-colors duration-200',
          className,
          { active: isActive }
        )
      }
    >
      {/* Check if it's a React Icon or an Image */}
      <span className='mr-2 flex items-center justify-center'>
        {isReactIcon ? (
          // Render React Icon directly
          React.createElement(icon, { className: 'w-4 h-4' })
        ) : (
          // Render Image
          <img src={icon} className='max-w-[18px]' alt='' />
        )}
      </span>
      {children}
    </NavLink>
  )
}
 
export default CustomNavLink





// import React from 'react'
// import { NavLink } from 'react-router-dom'

// const classNames = require('classnames')

// const CustomNavLink = ({ to, children, onClick, icon, isReactIcon, className }) => {
//   return (
//     <NavLink
//       to={to}
//       onClick={onClick}
//       className={({ isActive }) =>
//         classNames(
//           'flex items-center px-4 lg:px-7 py-3 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue transition-colors duration-200',
//           className,
//           { active: isActive }
//         )
//       }
//     >
//       {/* Check if it's a React Icon or an Image */}
//       <span className='mr-2 flex items-center justify-center'>
//         {isReactIcon ? (
//           // Render React Icon directly
//           React.createElement(icon, { className: 'w-4 h-4' })
//         ) : (
//           // Render Image
//           <img src={icon} className='max-w-[18px]' alt='' />
//         )}
//       </span>
//       {children}
//     </NavLink>
//   )
// }

// export default CustomNavLink